import React, { forwardRef } from 'react';

import type { LivenessNullableParameter } from '@vlabs/api/luna-api/model';
import { LIVENESS_OPTIONS } from '@vlabs/api-bindings/src/luna-client/constants';

import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function LivenessFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedLiveness = filters.liveness ?? [];

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={selectedLiveness.length === 0}
      onClickReset={() => updateFilters({ liveness: undefined })}
      ref={ref}
    >
      <OptionsFilter
        isSearchable={false}
        name="liveness"
        onChange={(value) => updateFilters({
          liveness: value.length > 0 ? (value as unknown as LivenessNullableParameter) : undefined,
        })}
        options={LIVENESS_OPTIONS.raw}
        value={selectedLiveness as unknown as string[]}
      />
      <div className={st.Divider} />
    </PopoverWithButton>
  );
}

const LivenessFilterPopoverWithRef = forwardRef(LivenessFilterPopover);
export { LivenessFilterPopoverWithRef as LivenessFilterPopover };
